import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChipComponent {
  @Input() icon = '';
  @Input() label = '';
  @Input() tone: 'blue' | 'green' | 'orange' | 'sky' | 'purple' | 'neutral' = 'neutral';
  @Input() showRequiredIndicator = false;
}
